import React from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Button, Box, Typography } from '@mui/material';
import stripeService from '../../services/stripe';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'context/Auth';
import Logo from "assets/images/logos/logo_blue.png";
interface Props {
  priceId: string;
  userId: string;
  amount: number;
  currency: string;
  onSuccess: () => void;
}

const StripeCheckoutForm = ({ priceId, userId, amount, currency, onSuccess }: Props) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [error, setError] = React.useState<string | null>(null);
  const [processing, setProcessing] = React.useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!stripe || !elements) return;

    setProcessing(true);

    try {
      const { error, setupIntent } = await stripe.confirmSetup({
        elements,
        confirmParams: {
          return_url: window.location.origin,
        },
        redirect: 'if_required',
      });

      if (error) {
        throw new Error(error.message || 'Payment failed');
      }

      // If we get here, payment succeeded and there was no redirect
      await stripeService.createSubscription({
        priceId,
        userId,
        setupIntentId: setupIntent?.id,
      });

      await refreshUser();
      onSuccess();
    } catch (e: any) {
      console.log('e', e);
      setError(e?.response?.data?.error || e.message || 'An unexpected error occurred');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ mb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
          <img
            key="title"
            src={Logo}
            width={200}
            alt="CityView CMS Logo"
          />
        </Box>
        <PaymentElement
          options={{
            layout: {
              type: 'tabs',
              defaultCollapsed: false,
            }
          }}
        />
      </Box>
      {error && (
        <Typography color="error" sx={{ mb: 2 }}>
          {error}
        </Typography>
      )}
      <Button
        type="submit"
        variant="contained"
        fullWidth
        disabled={!stripe || processing}
        sx={{ mt: 2 }}
      >
        {processing ? 'Processing...' : 'Subscribe'}
      </Button>
    </form>
  );
};

export default StripeCheckoutForm;